(function (window, app, overwatch) {

    $('[data=blog-body] .lightbox').on('click', function (e) {
        var classOverride = $(this).data("lightboxClass");
        app.helpers.loadImageIntoFrame($(this).attr('href'), classOverride);
        return false;
    });

    $('.blog-load-more a').click(loadMoreNews);

    var currentPage = 1;

    function loadMoreNews() {
        currentPage++;
        $.get('/' + window.blizzard.urlLocale + '/blog/next-posts', { page: currentPage })
            .then(function processNextPosts(results) {
                $('.blog-roll .blog-list').append(results.content);

                if (results.totalPages == results.page) {
                    $('.blog-load-more').hide();
                    return false;
                }
            });
    }
}(window, window.app, window.overwatch));
